import React, { useState } from 'react';
import './Disruption.css';

//The Disruption component displays a disruption scenario and 
// shows the decision that a group has already made
// Users can select one of the choices and click “Submit Choice” to record their response
// This form simulates a decision-making moment in a role-play or game-based scenario, 

function Disruption() {
    let [decision, setDecision] = useState('decision placeholder');
    let [disruption, setDisruption] = useState('disruption placeholder');

    const loadDisruption = (event) => {
        setDisruption('xxxx.')
    }

    const loadDecision = (event) => {
        setDecision('xxxxx.');
    }

    const submit = () => {
        console.log('submit attempted')
    }

    return (
        <div>
            <form action="/complete" method="get">
                <div style={{ textAlign: 'center' }}>
                    <h2>
                        Disruption Name Placeholder
                    </h2>
                    <p>
                        {/*Loading the disruption prompt from db*/}
                        {disruption}
                    </p>
                    <p>
                        {/*Loading the decisions made by this group from db*/}
                        Your team selected: {decision}
                    </p>
                    <div>
                        {/*Loading the choices for this disruption from db*/}
                        <div>
                            <input type="radio" id="choice1" name="choice" value="A" />
                            <label for="choice1">A</label>
                        </div>
                        <div>
                            <input type="radio" id="choice2" name="choice" value="B" />
                            <label for="choice2">B</label>
                        </div>
                        <div>
                            <input type="radio" id="choice3" name="choice" value="C" />
                            <label for="choice3">C</label>
                        </div>
                        <div>
                            <input type="radio" id="choice4" name="choice" value="D" />
                            <label for="choice4">D</label>
                        </div>
                    </div>
                    <div>
                        <button onClick={submit}>
                            Submit Choice
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default Disruption;